module.exports = __webpack_public_path__ + "static/img/clockit_login.3ba91c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clockit_login.png
// module id = BN+n
// module chunks = 1